package com.tixforgigs.common.core.util


import com.tixforgigs.common.core.util.StorageUtil.getLocalStorageItem
import com.tixforgigs.common.core.util.StorageUtil.setLocalStorageItem
import kotlinx.serialization.builtins.serializer
import kotlin.uuid.Uuid

internal actual fun getPlatformUniqueId(): Uuid {
  return getLocalStorageItem<String>(StorageUtil.StorageKey.UniqueId)?.let {
    runCatching { Uuid.parse(it) }.getOrNull()
  } ?: Uuid.random().also {
    setLocalStorageItem(StorageUtil.StorageKey.UniqueId, it.toString(), String.serializer())
  }
}

internal actual suspend fun getDeviceId(): String {
  return getPlatformUniqueId().toString()
}
